import { render, staticRenderFns } from "./base-alert.vue?vue&type=template&id=f132f48c"
import script from "./base-alert.vue?vue&type=script&lang=js"
export * from "./base-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports